var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 176,
    viewBox: "0 0 177 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bank_svg__filter0_d_3871_29542)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.211,
    y: 26,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F6F8FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bank_svg__clip0_3871_29542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.417 77.282H76.93v25.128h19.487V77.282z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.861 93.593v8.907h-8.379v-8.907a4.19 4.19 0 118.38 0z",
    fill: "#D8E0FF",
    stroke: "#2C5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.622 102.41H68.725v3.077h35.897v-3.077z",
    fill: "#D8E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.134 106H68.211v-4.103h36.923V106zm-35.897-1.026h34.871v-2.051H69.237v2.051z",
    fill: "#2C5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.725 76.769v-3.053l17.948-7.075 17.949 7.075v3.053H68.725z",
    fill: "#D8E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.134 77.282H68.211v-3.915l18.462-7.277 18.461 7.277v3.915zm-35.897-1.026h34.871v-2.192l-17.436-6.872-17.435 6.872v2.192z",
    fill: "#2C5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.929 79.846h-5.128v22.564h5.128V79.846z",
    fill: "#D8E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.441 102.924h-6.154v-23.59h6.154v23.59zm-5.128-1.026h4.102V80.36h-4.102v21.538z",
    fill: "#2C5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.544 79.846h-5.128v22.564h5.128V79.846z",
    fill: "#D8E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.056 102.924h-6.154v-23.59h6.154v23.59zm-5.128-1.026h4.103V80.36h-4.103v21.538z",
    fill: "#2C5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.98 76.77h-9.23v3.077h9.23v-3.078z",
    fill: "#D8E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.467 77.281v2.052h-8.205V77.28h8.205zm1.026-1.025H69.236v4.102h10.257v-4.102z",
    fill: "#2C5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.596 76.77h-9.23v3.077h9.23v-3.078z",
    fill: "#D8E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.082 77.281v2.052h-8.205V77.28h8.205zm1.026-1.025H93.852v4.102h10.256v-4.102z",
    fill: "#2C5BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bank_svg__clip0_3871_29542"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(68.21 66)",
    d: "M0 0h36.923v40H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bank_svg__filter0_d_3871_29542",
    x: 0.211,
    y: 0,
    width: 176,
    height: 176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.155 0 0 0 0 0.231506 0 0 0 0 0.516667 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3871_29542"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3871_29542",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "media/photographerOnboarding/bank-37b18bec.svg";
export { SvgBank as ReactComponent };